import { STATION_MODE_SETTING } from '../../utils/station/settings';
import { useStationSetting } from './useStationSetting';

/**
 * Hook to check if the app is in Station mode.
 * Reads from URL parameter mode=ces or mode=station initially, then persists in localStorage.
 * @returns true if Station mode is active, false otherwise
 */
export const useStationMode = (): boolean =>
  useStationSetting(STATION_MODE_SETTING);
